import Button, { ButtonVariants } from 'components/button/button';
import Popover from 'components/popover/popover';
import {
  companyIcon,
  contentIcon,
  folder2Icon,
  playlistsIcon,
  ROUTES,
  screenGreyIcon,
  WebIcon,
  whiteAddIcon,
} from 'constants/index';
import { ModalViews, UserRoles } from 'enums';
import { uuid } from 'helpers';
import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from 'store';
// import { layoutActions } from 'store/actions';
import { layoutActions } from 'store/actions';
import { iState } from 'types';
import styles from './header.module.scss';

interface iProps {
  className?: string;
}

const PLAYLIST_ADD_OPTIONS = [
  {
    id: uuid(),
    icon: playlistsIcon,
    option: 'New Playlist',
    action: 'mainOperation',
  },
  { id: uuid(), icon: folder2Icon, option: 'New folder', action: 'addFolder' },
];
const SCREENS_ADD_OPTIONS = [
  {
    id: uuid(),
    icon: screenGreyIcon,
    option: 'New Screen',
    action: 'mainOperation',
  },
  { id: uuid(), icon: folder2Icon, option: 'New folder', action: 'addFolder' },
];
const CONTENT_ADD_OPTIONS = [
  {
    id: uuid(),
    icon: contentIcon,
    option: 'Add Content',
    action: 'mainOperation',
  },
  { id: uuid(), icon: folder2Icon, option: 'New folder', action: 'addFolder' },
  {
    id: uuid(),
    icon: WebIcon,
    option: 'Add webpage',
    action: 'addWebPage',
  },
];

function Header(props: iProps): JSX.Element {
  const { className } = props;
  const [state, dispatch]: [iState, any] = useStore();
  const { user } = state || {};
  const { pathname } = useLocation();
  const { isShowingClientInstance } = state.layout || {};

  const activeView = user.userSettings.activeView !== 'General';
  const role = user.role !== UserRoles.Client;
  // useEffect(() => {
  //   console.log(state.user);
  // }, [state, dispatch]);

  const addContent = useCallback(() => {
    // if (user.role === UserRoles.SuperAdmin || !isShowingClientInstance)
    //   dispatch(layoutActions.toggleModal(ModalViews.isShowAddClient));
    if (isShowingClientInstance && pathname === ROUTES.home)
      dispatch(layoutActions.toggleModal(ModalViews.isShowAddScreen));
    if (user.role === UserRoles.Reseller)
      dispatch(layoutActions.toggleModal(ModalViews.isShowAddClient));
    if (user.role === UserRoles.Client)
      dispatch(layoutActions.toggleModal(ModalViews.isShowAddScreen));
    // if (pathname === ROUTES.home)
    //   dispatch(layoutActions.toggleModal(ModalViews.isShowAddScreen));
    if (pathname === ROUTES.content)
      // dispatch(layoutActions.openAddContentModal());
      dispatch(layoutActions.toggleModal(ModalViews.isShowAddContent));
    if (pathname === ROUTES.playlists)
      dispatch(layoutActions.toggleModal(ModalViews.isShowAddPlaylist));
  }, [user, dispatch, pathname, isShowingClientInstance]);

  const addFolder = useCallback(() => {
    // if (user.role === UserRoles.SuperAdmin)
    //   dispatch(layoutActions.toggleModal(ModalViews.isShowAddFolder));
    // if (user.role === UserRoles.Reseller)
    //   dispatch(layoutActions.toggleModal(ModalViews.isShowAddFolder));
    // if (user.role === UserRoles.Client)
    //   dispatch(layoutActions.toggleModal(ModalViews.isShowAddFolder));
    // if (pathname === ROUTES.playlists)
    //   dispatch(
    //     layoutActions.toggleModal(ModalViews.isShowAddFolderForPlaylists)
    //   );
    dispatch(layoutActions.toggleModal(ModalViews.isShowAddFolder));
  }, [dispatch]);

  const addWebPage = useCallback(() => {
    if (pathname === ROUTES.content)
      dispatch(layoutActions.toggleModal(ModalViews.isShowAddWebContent));
  }, [pathname, dispatch]);

  const isSuperUserAdmin = user.role === UserRoles.SuperAdmin;
  const isClient = user.role === UserRoles.Client;
  const isResellerAdmin = user.role === UserRoles.Reseller;

  const heading =
    (isShowingClientInstance &&
      isSuperUserAdmin &&
      pathname === ROUTES.home &&
      'Your Screens') ||
    (pathname === ROUTES.playlists && 'Your Playlists') ||
    (pathname === ROUTES.roles && 'Roles settings') ||
    (pathname === ROUTES.content && 'Your Content') ||
    (pathname === ROUTES.userSettings && 'Your Settings') ||
    (isSuperUserAdmin && 'Your Clients') ||
    (isClient && 'Your Screens') ||
    (isResellerAdmin && 'Your Clients');

  const onTeammateClick = useCallback(() => {
    dispatch(layoutActions.toggleModal(ModalViews.isShowAddTeammate));
  }, [dispatch]);
  const addBtnOptions =
    (pathname === ROUTES.home && SCREENS_ADD_OPTIONS) ||
    (pathname === ROUTES.playlists && PLAYLIST_ADD_OPTIONS) ||
    (pathname === ROUTES.content && CONTENT_ADD_OPTIONS) ||
    [];

  return (
    <div className={`${className} ${styles.headerWrapper}`}>
      <span className={styles.title}>{heading}</span>
      {pathname === ROUTES.userSettings ? (
        <Popover
          className={styles.popoverWrapper}
          popoverClassName={styles.mobileDropdownBtn}
          popoverComponent={<div />}
        >
          {pathname === ROUTES.userSettings && activeView && role ? (
            <Button
              className={`${styles.mobileDropdownBtn}`}
              variant={ButtonVariants.SmallStd}
              btnName="Screen"
              icon={whiteAddIcon}
              onClick={onTeammateClick}
              isSupportResponsive
            />
          ) : (
            <div />
          )}
        </Popover>
      ) : (
        <Popover
          className={styles.popoverWrapper}
          popoverClassName={styles.mobileDropdownBtn}
          popoverComponent={
            <div className={`${styles.playlistDropdown} ${className}`}>
              {isShowingClientInstance || isClient ? (
                addBtnOptions.map((i) => (
                  <div
                    className={styles.option}
                    onClick={() => {
                      if (i.action === 'mainOperation') addContent();
                      if (i.action === 'addWebPage') addWebPage();
                      if (i.action === 'addFolder') addFolder();
                    }}
                  >
                    <img src={i.icon} alt="" />
                    <span>{i.option}</span>
                  </div>
                ))
              ) : (
                <div
                  className={styles.option}
                  onClick={() => {
                    dispatch(
                      layoutActions.toggleModal(ModalViews.isShowAddClient)
                    );
                  }}
                >
                  <img src={companyIcon} alt="" />
                  <span>New Client</span>
                </div>
              )}
            </div>
          }
        >
          <Button
            className={`${styles.mobileDropdownBtn}`}
            variant={ButtonVariants.SmallStd}
            btnName="Screen"
            icon={whiteAddIcon}
            isSupportResponsive
          />
        </Popover>
      )}

      {/* <Button
        className={`${styles.addScreensBtn}`}
        variant={ButtonVariants.SmallStd}
        btnName="Screen"
        icon={whiteAddIcon}
        isSupportResponsive
        onClick={onClickAdd}
      /> */}
    </div>
  );
}

Header.defaultProps = {
  className: '',
};

export default Header;
